import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { logout } from '../utils/auth';

const { FiLogOut } = FiIcons;

const LogoutButton = ({ onLogout }) => {
  const handleLogout = () => {
    logout();
    onLogout();
  };

  return (
    <motion.button
      onClick={handleLogout}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className="flex items-center space-x-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200"
      title="Logout"
    >
      <SafeIcon icon={FiLogOut} />
      <span>Logout</span>
    </motion.button>
  );
};

export default LogoutButton;